import { render, staticRenderFns } from "./DataStats.vue?vue&type=template&id=91593792&scoped=true"
import script from "./DataStats.vue?vue&type=script&lang=js"
export * from "./DataStats.vue?vue&type=script&lang=js"
import style0 from "./DataStats.vue?vue&type=style&index=0&id=91593792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91593792",
  null
  
)

export default component.exports